
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dtm",
      function () {
        return require("private-next-pages/dtm/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dtm"])
      });
    }
  